import EasyPassClient from './EasyPassClient';
import SearchServiceClient from './SearchServiceClient';

class FilterClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.searchServiceClient = new SearchServiceClient();
    this.easyPassRootUri = 'api/acvapi/v3';
    this.rootUri = 'filters';
    this.customHeaders = {
      'json-naming-strategy': 'camel',
    };
    this.conditionOptions = null;
  }

  searchAutocomplete(params) {
    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/textsearch/autocomplete`, params);
  }

  searchHistory() {
    const params = {
      count: 20,
    };

    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/textsearch/history`, params);
  }

  getFiltersAuctionsSearchFilters(searchTerms) {
    return this.searchServiceClient.getFilters(searchTerms);
  }

  getFiltersAuctionsSearchSuggestions(searchTerms) {
    return this.searchServiceClient.getSearchSuggestions(searchTerms);
  }

  getFilterOptions() {
    return this.searchServiceClient.getFilterOptions();
  }

  getTrimOptions(makes, models) {
    const params = new URLSearchParams([
      ...makes.map((make) => ['make', make]),
      ...models.map((model) => ['model', model]),
    ]);

    return this.searchServiceClient.getTrimOptions(params);
  }

  async getConditionOptions() {
    // this response requires a code change and a release to alter, so it's pretty safe to store it
    if (this.conditionOptions === null) {
      this.conditionOptions = await this.searchServiceClient.getConditionOptions();
    }

    // clone the response so it doesn't get clobbered
    return JSON.parse(JSON.stringify(this.conditionOptions));
  }

  saveRecentSearch(filters, useSearchService = false) {
    if (useSearchService) {
      return this.searchServiceClient.saveRecentSearch(filters);
    }

    return this.easyPassClient.post('query-engine/auctions/buying/search/recent', { filters }, this.customHeaders);
  }
}

export default FilterClient;
